module.exports = __webpack_public_path__ + "img/axt1.8719b6b9.png";